const notifications = () => document.querySelector(".notifications");

const toastDetails = {
    timer: 6000,
    success: {
        icon: 'fa-circle-check',
        text: 'Success: This is a success toast.',
        title: 'Success: This is a success Y/N.',
        sub: 'This won\'t affect anything.',
    },
    error: {
        icon: 'fa-circle-xmark',
        text: 'Error: This is an error toast.',
        title: 'Error: This is an error Y/N.',
        sub: 'This won\'t affect anything.',
    },
    warning: {
        icon: 'fa-triangle-exclamation',
        text: 'Warning: This is a warning toast.',
        title: 'Warning: This is a warning Y/N.',
        sub: 'This won\'t affect anything.',
    },
    info: {
        icon: 'fa-circle-info',
        text: 'Info: This is an information toast.',
        title: 'Info: This is an information Y/N.',
        sub: 'This won\'t affect anything.',
    },
    pending: {
        icon: 'fa-circle-notch fa-spin',
        text: 'Pending: This is a pending toast.',
        title: 'Pending: This is a pending Y/N.',
        sub: 'This won\'t affect anything.',
    },
}

const removeToast = (toast) => {
    toast.classList.add("hide");
    if (toast.timeoutId) clearTimeout(toast.timeoutId); // Clearing the timeout for the toast
    setTimeout(() => function () { toast.remove(); currentToast = null; }, 1250); // Removing the toast after 500ms
 
}

const updateToast = (toast, type, text = null) => {
    const { icon, text: dtext } = toastDetails[type];
    if (text == null) text = dtext;
    toast.innerHTML = `<div class="column">
                         <span>${text}</span>
                      </div>
                      <i class="fa-solid fa-xmark" onclick="removeToast(this.parentElement)"></i>`;
    notifications().appendChild(toast); // Append the toast to the notification ul
    // Setting a timeout to remove the toast after the specified duration
    if (type != "pending") toast.timeoutId = setTimeout(() => removeToast(toast), toastDetails.timer);
    return toast;
}

// Store reference to current toast
let currentToast = null;

const createToast = (type, text = null) => {
    // Remove existing toast if present
    if (currentToast) {
        currentToast.remove();
    }

    const { icon, text: dtext } = toastDetails[type];
    if (text == null) text = dtext;

    const toast = document.createElement("li");
    toast.className = `toast ${type}`;
    toast.innerHTML = `<div class="column" onclick="removeToast(this.parentElement)">
                         <span class="textToast">${text}</span>
                      </div>`;

    notifications().appendChild(toast);

    if (type !== "pending") {
        toast.timeoutId = setTimeout(() => removeToast(toast), toastDetails.timer);
    }

    // Store reference to new toast
    currentToast = toast;
    return toast;
};

